import {InjectionToken} from '@angular/core';

export const APP_GUIDS = new InjectionToken('guids');

export const appGuids: AppGuids = {
  GUID_ACTION_ACCEPT_CHANGE: 'c045bedc-2c9c-11b2-8015-6d89bf6595fe',
  GUID_ACTION_CREATE_BM_DELIVERY: 'baf9ff2e-2c9c-11b2-804e-7b615b880ea4',
  GUID_PSETYP_BM: 'e9c75930-2bd1-11b2-8005-739a5d40590d',
  GUID_CHANNEL_EXTERNAL: '3a4210c8-2c07-11b2-801b-6755d5e25f6a',
  GUID_CHANNEL_INTERNAL: 'eb880ca2-2c52-11b2-80c2-6146723ac734',
  GUID_CHANNEL_PM: '71559be6-2cae-11b2-809d-c59ab52e976b',
  GUID_SCRIPT_PBO_PROJECT_INFO_EXTERN: 'f58c0b9e-2ca3-11b2-80c8-013d36df4a22',
  GUID_SCRIPT_PBO_PROJECT_INFO_INTERN: 'f58c0c35-2ca3-11b2-80c8-013d36df4a22',
  GUID_SCRIPT_PSE_CREATE_DELIVERYNOTE_EXTERN:
    '32247448-2c49-11b2-80ce-5b47e4bd1ab4',
  GUID_OPEN: '08d73ab3-2c49-11b2-8040-6d42c7fc1987',
  GUID_DELIVERED: '8f999f30-2925-11b2-8055-278188925e2c',
  GUID_CANCELED: '99127406-2925-11b2-80c0-c15c07a3da04',
  GUID_REPORT_PLANNED_DELIVERY_COUNT: 'b7e3dd84-2ca4-11b2-80ef-3da85742538d',
  GUID_REPORT_REQUESTED_DELIVERY_COUNT: 'b5924f80-2c12-11b2-8072-65aa57558d96',
  GUID_REPORT_ESTIMATED_DELIVERYCURVE: 'b5924e40-2c12-11b2-8072-65aa57558d96',
  GUID_REPORT_ACTUAL_DELIVERY_COUNT: '25e41fd8-2ca5-11b2-804e-f9a5f0392042',
  GUID_ORDER_DELIVERED_STATUS: '8f999f30-2925-11b2-8055-278188925e2c',
  GUID_SCRIPT_PSE_TL_EXTERN_SUPPLIER_CREATE_PBO_DOCUMENT:
    '1c0e609c-2ce4-11b2-803e-497fc51bf5ad',
  GUID_TEILE_TYP: 'b514dea4-27fa-11b2-800a-b390cd5bbe84',
  GUID_PSETYP_TB: 'b514cb1c-27fa-11b2-800a-b390cd5bbe84',
  GUID_SCRIPT_VORFALL_ACCEPT: '37373c74-2cf1-11b2-8028-73194f132951',
  GUID_INCIDENT_STATUS_OPEN: '944f214a-29f1-11b2-80dc-b9b16226d298',
  GUID_INCIDENT_STATUS_ACCEPTED: '944f1c86-29f1-11b2-80dc-b9b16226d298',
  GUID_ACTION_COMMENT: 'b2005ef0-2b1a-11b2-80e7-d585c8e606e4',
  GUID_TYPE_RECEIVE_QS_PARTS: '56170b70-2c9b-11b2-80a6-cdcb704d6032',
  GUID_ACTION_IMPORT_PRISMA_DOCUMENTS: '479f8632-2d02-11b2-80a3-a7daec67c34d',
  GUID_ACTION_IMPORT_PRISMA_SNRS: '025389d6-2d14-11b2-8093-e7f08f84f3b8',
  GUID_UPLOAD_WERKZEUGABNAHME_PROTOKOLL_ACTION:
    '87190b1a-2d22-11b2-80b7-25201de251c9',
  GUID_SCRIPT_PSE_WAP_EXTERN: '8095a2b2-2d22-11b2-80a8-d712403e5ef7',
  GUID_TYPE_SUPPLIER: '2c822196-2813-11b2-800f-09da23dd9627',
  GUID_TYPE_CONTACT: '2c823212-2813-11b2-800f-09da23dd9627',
  GUID_ACTION_DELETE_PM_OBJECT: '46c945c8-2d3d-11b2-80c4-4f68b5bc7a06',
  GUID_PR_STATUS_NOTAPPL: '130e6902-2c07-11b2-80a4-1b2cfea31215',
  GUID_UPLOAD_INSPECTION_REPORT: '90759948-2d91-11b2-80c6-3f8ba297659b',
  GUID_SCRIPT_TEILE_CREATE_PROJECT_INFO_PLATINEN:
    '32270a52-2d96-11b2-8085-9d6593c3f82b',
  GUID_SCRIPT_TEILE_DELETE_PROJECT_INFO_PLATINEN:
    '32270b42-2d96-11b2-8085-9d6593c3f82b',
  GUID_UPLOAD_MESSPROTOKOLL_ACTION: '5cd64f1a-2de1-11b2-807c-d705f681fe98'
};

export interface AppGuids {
  GUID_CHANNEL_INTERNAL: string;
  GUID_CHANNEL_EXTERNAL: string;
  GUID_CHANNEL_PM: string;
  GUID_PSETYP_BM: string;
  GUID_TEILE_TYP: string;
  GUID_PSETYP_TB: string;
  GUID_ACTION_ACCEPT_CHANGE: string;
  GUID_ACTION_CREATE_BM_DELIVERY: string;
  GUID_SCRIPT_PBO_PROJECT_INFO_EXTERN: string;
  GUID_SCRIPT_PBO_PROJECT_INFO_INTERN: string;
  GUID_SCRIPT_PSE_CREATE_DELIVERYNOTE_EXTERN: string;
  GUID_SCRIPT_PSE_TL_EXTERN_SUPPLIER_CREATE_PBO_DOCUMENT: string;
  GUID_OPEN: string;
  GUID_DELIVERED: string;
  GUID_CANCELED: string;
  GUID_REPORT_ESTIMATED_DELIVERYCURVE: string;
  GUID_REPORT_PLANNED_DELIVERY_COUNT: string;
  GUID_REPORT_ACTUAL_DELIVERY_COUNT: string;
  GUID_REPORT_REQUESTED_DELIVERY_COUNT: string;
  GUID_ORDER_DELIVERED_STATUS: string;
  GUID_SCRIPT_VORFALL_ACCEPT: string;
  GUID_INCIDENT_STATUS_OPEN: string;
  GUID_INCIDENT_STATUS_ACCEPTED: string;
  GUID_ACTION_COMMENT: string;
  GUID_TYPE_RECEIVE_QS_PARTS: string;
  GUID_ACTION_IMPORT_PRISMA_DOCUMENTS: string;
  GUID_ACTION_IMPORT_PRISMA_SNRS: string;
  GUID_UPLOAD_WERKZEUGABNAHME_PROTOKOLL_ACTION: string;
  GUID_UPLOAD_MESSPROTOKOLL_ACTION: string;
  GUID_SCRIPT_PSE_WAP_EXTERN: string;
  GUID_TYPE_SUPPLIER: string;
  GUID_TYPE_CONTACT: string;
  GUID_ACTION_DELETE_PM_OBJECT: string;
  GUID_PR_STATUS_NOTAPPL: string;
  GUID_UPLOAD_INSPECTION_REPORT: string;
  GUID_SCRIPT_TEILE_CREATE_PROJECT_INFO_PLATINEN: string;
  GUID_SCRIPT_TEILE_DELETE_PROJECT_INFO_PLATINEN: string;
}
